import React from "react";
import { MdOutlineArrowLeft } from "react-icons/md";


const Vegetarian = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Vegetarian Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/menu">
                  <p className="text-blue-700">Back</p>
                </a>
              </div>
            </div>
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class=" tourney lg:grid lg:grid-cols-6 grid grid-cols-2 -m-4 mx-2 mt-0.5 text-center   ">
            <div class="p-4 md:w-1/4 lg:w-[200px]  ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Paneer Butter Masala.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PANEER BUTTER MASALA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]  ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Vegetable Biryani.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  VEGETABLE BIRYANI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px] ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Dal Makhani.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  DAL MAKHANI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px] ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Aloo Gobi.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  ALOO GOBI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px] ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Palak Paneer.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PALAK PANEER
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px] ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Shahi Paneer.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  SHAHI PANEER
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px] ">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Chana Masala.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHANA MASALA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Baingan Bharta.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BAINGAN BHARTA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Rajma.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  RAJMA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Aloo Paratha.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  ALOO PARATHA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Masala Dosa.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  MASALA DOSA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Sambhar.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  SAMBHAR
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Avial.JPG"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  AVIAL
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Pesarattu.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PESARATTU
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Vegetable Upma.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  VEGETABLE UPMA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Bisi Bele Bath.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BISI BELE BATH
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Akki Roti.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  AKKI ROTI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Ragi Mudde.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  RAGI MUDDE
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Vangi Bath.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  VANGI BATH
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Kosambari.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  KOSAMBARI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Vegetable Palya.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  VEGETABLE PALYA
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Puri Saagu.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PURI SAAGU
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Puliyogare.jpeg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  PULIYOGARE
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Vegetarian\Lemon Rice.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  LEMON RICE
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Vegetarian;
